import _range from "lodash/range";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import classnames from 'classnames';
import FieldContainer from "../FieldContainer";
import injectStyles from "../jss";
import FormLabel from "../FormLabel";
import styles, { TEXT_INDENT, TEXT_INDENT_NARROW, SEPARATED_INPUT_PADDING } from "./MultiField.jss";
var BACKSPACE_KEY_CODE = 8;
var LEFT_ARROW_KEY_CODE = 37;
export var MultiField = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MultiField, _React$PureComponent);

  function MultiField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MultiField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MultiField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      charWidth: 0,
      focusedElement: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRefs", _this.props.fields.map(function () {
      return React.createRef();
    }));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "totalValueLength", _this.getTotalValueLength());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (_ref) {
      var target = _ref.target;
      var onChange = _this.props.onChange;

      _this.ensureInputMaxLength(target);

      onChange(_this.getEvent());
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputKeyDown", function (_ref2) {
      var _ref2$target = _ref2.target,
          name = _ref2$target.name,
          value = _ref2$target.value,
          maxLength = _ref2$target.maxLength;

      var currentFieldIndex = _this.getCurrentFieldIndex(name);

      var field = _this.inputRefs[currentFieldIndex].current;

      if (field && value && maxLength === 1) {
        field.setSelectionRange(0, 9999);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlePaste", function (_ref3) {
      var clipboardData = _ref3.clipboardData; // eslint-disable-line no-undef

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          fields = _this$props.fields;
      var clipboardText = clipboardData.getData('Text');
      var charInputCount = 0;
      var inputIndex = 0;

      for (var i = 0; i < clipboardText.length; i++) {
        if (_this.inputRefs[inputIndex] && _this.inputRefs[inputIndex].current !== null) {
          if (!charInputCount) {
            _this.inputRefs[inputIndex].current.value = '';
          }

          _this.inputRefs[inputIndex].current.value += clipboardText[i];
          charInputCount += 1;

          if (charInputCount === fields[inputIndex].length) {
            inputIndex += 1;
            charInputCount = 0;
          }
        } else {
          break;
        }
      }

      onChange(_this.getEvent());
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputKeyUp", function (_ref4) {
      var keyCode = _ref4.keyCode,
          _ref4$target = _ref4.target,
          maxLength = _ref4$target.maxLength,
          name = _ref4$target.name,
          value = _ref4$target.value;

      var currentFieldIndex = _this.getCurrentFieldIndex(name);

      var backspaceKeyPressed = keyCode === BACKSPACE_KEY_CODE;
      var leftArrowPressed = keyCode === LEFT_ARROW_KEY_CODE;
      var isLetterOrNumber = /^[A-Za-z0-9А-Яа-яЁё]+$/.test(value);
      var isEmptyValue = value === '';
      var isFirstField = currentFieldIndex === 0;
      var isLastField = currentFieldIndex === _this.props.fields.length - 1;
      var hasReachedMaxLength = value.length === maxLength;

      if (!leftArrowPressed && !backspaceKeyPressed && !isLetterOrNumber) {
        return;
      }

      if ((backspaceKeyPressed && isEmptyValue || leftArrowPressed) && !isFirstField) {
        _this.jumpToPreviousField(currentFieldIndex);
      } else if (hasReachedMaxLength && !isLastField && !leftArrowPressed) {
        _this.jumpToNextBox(currentFieldIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputOnBlur", function (_ref5) {
      var target = _ref5.target;
      var _this$props2 = _this.props,
          onBlur = _this$props2.onBlur,
          fields = _this$props2.fields;

      if (!onBlur) {
        return;
      }

      var shouldBlur = target === _this.inputRefs[fields.length - 1].current;

      if (shouldBlur) {
        onBlur(_this.getEvent());
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setFocusedElement", function (_ref6) {
      var target = _ref6.target;

      _this.setState({
        focusedElement: target
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusOnInput", function (event) {
      event.stopPropagation();
      var focusedElement = _this.state.focusedElement;

      if (!focusedElement) {
        if (_this.inputRefs[0].current) {
          _this.inputRefs[0].current.focus();
        }

        return;
      }

      if (event.target !== document.activeElement) {
        focusedElement.focus();
      }
    });

    return _this;
  }

  _createClass(MultiField, [{
    key: "getTotalValueLength",
    value: function getTotalValueLength() {
      var _this$props3 = this.props,
          delimiter = _this$props3.delimiter,
          fields = _this$props3.fields;
      var delimiterLength = (delimiter || '').length * (fields.length - 1);
      return fields.reduce(function (acc, field) {
        return acc + field.length;
      }, 0) + delimiterLength;
    }
  }, {
    key: "getRangeValue",
    value: function getRangeValue() {
      var _this2 = this;

      var fields = this.props.fields;
      return _range(fields.length).map(function (i) {
        var field = _this2.inputRefs[i].current;
        return (field && field.value || '').toString();
      });
    }
  }, {
    key: "getTextValue",
    value: function getTextValue() {
      var delimiter = this.props.delimiter;
      return this.getRangeValue().join(delimiter);
    }
  }, {
    key: "getInputValue",
    value: function getInputValue(key) {
      var _this$props4 = this.props,
          delimiter = _this$props4.delimiter,
          fields = _this$props4.fields,
          value = _this$props4.value;

      if (value === undefined || value === null) {
        return null;
      }

      var parts;

      if (!value.length || value.length === this.totalValueLength) {
        parts = value.split(delimiter);
      } else {
        parts = this.getRangeValue();
      }

      if (parts[key] === undefined) {
        return '';
      }

      return parts[key].substr(0, fields[key].length);
    }
  }, {
    key: "getEvent",
    value: function getEvent() {
      var name = this.props.name;
      return {
        name: name,
        value: this.getTextValue(),
        type: 'MultiField'
      };
    } // with the type="number" we have to check length of the inputed value
    // manually, because maxLength doesn't work for type="number"

  }, {
    key: "ensureInputMaxLength",
    value: function ensureInputMaxLength(element) {
      var maxLength = element.maxLength,
          value = element.value;

      if (value.length > maxLength) {
        element.value = value.substr(0, maxLength); // eslint-disable-line no-param-reassign
      }
    }
  }, {
    key: "jumpToField",
    value: function jumpToField(fieldIndex) {
      var input = this.inputRefs[fieldIndex].current;

      if (input) {
        input.focus();

        if (input.value) {
          input.setSelectionRange(0, 9999);
        }
      }
    }
  }, {
    key: "jumpToPreviousField",
    value: function jumpToPreviousField(currentFieldIndex) {
      this.jumpToField(currentFieldIndex - 1);
    }
  }, {
    key: "jumpToNextBox",
    value: function jumpToNextBox(currentFieldIndex) {
      this.jumpToField(currentFieldIndex + 1);
    }
  }, {
    key: "getLabel",
    value: function getLabel(labelString) {
      if (!labelString) {
        return null;
      }

      var _this$props5 = this.props,
          classes = _this$props5.classes,
          name = _this$props5.name;
      return React.createElement(FormLabel, {
        name: name,
        className: classes.multiLabel
      }, labelString);
    }
  }, {
    key: "getCurrentFieldIndex",
    value: function getCurrentFieldIndex(name) {
      return parseInt(name.split('_')[1], 10);
    }
  }, {
    key: "renderLabelByIndex",
    value: function renderLabelByIndex(inputIndex) {
      var label = this.props.label;
      var isMultiLabel = Array.isArray(label);
      var labelString = label ? label[inputIndex] : '';
      return isMultiLabel ? this.getLabel(labelString) : null;
    }
  }, {
    key: "renderTeeth",
    value: function renderTeeth(count) {
      var _this3 = this;

      var _this$props6 = this.props,
          classes = _this$props6.classes,
          narrow = _this$props6.narrow;
      return React.createElement("div", {
        className: classes.teeth
      }, _range(count + 1).map(function (index) {
        return React.createElement("div", {
          key: index,
          className: classnames(classes.char, classes.tooth, narrow && classes.charSmall),
          style: {
            width: "".concat(_this3.state.charWidth, "px")
          }
        });
      }));
    }
  }, {
    key: "calculateInputWidth",
    value: function calculateInputWidth(length) {
      var _this$props7 = this.props,
          narrow = _this$props7.narrow,
          separated = _this$props7.separated;
      var charWidth = this.state.charWidth;
      var charsWidth = Math.ceil(length * charWidth);

      if (separated) {
        return charsWidth + SEPARATED_INPUT_PADDING * 2;
      } // Adding 1px to fix offset on iOS


      return charsWidth + (narrow ? TEXT_INDENT_NARROW : TEXT_INDENT) + 1;
    }
  }, {
    key: "renderInput",
    value: function renderInput(field, key) {
      var _classnames;

      var _this$props8 = this.props,
          classes = _this$props8.classes,
          delimiter = _this$props8.delimiter,
          disabled = _this$props8.disabled,
          fields = _this$props8.fields,
          name = _this$props8.name,
          narrow = _this$props8.narrow,
          separated = _this$props8.separated,
          showDelimiter = _this$props8.showDelimiter;
      var length = field.length,
          type = field.type,
          placeholder = field.placeholder;
      var isLastGroup = key === fields.length - 1;
      var className = classnames((_classnames = {}, _defineProperty(_classnames, classes.char, true), _defineProperty(_classnames, classes.input, true), _defineProperty(_classnames, classes.charSmall, narrow), _defineProperty(_classnames, classes.inputSmall, narrow), _defineProperty(_classnames, classes.separatedInput, separated), _defineProperty(_classnames, classes.disabled, disabled), _classnames));
      return React.createElement("div", {
        key: key,
        className: classes.fieldGroup
      }, this.renderLabelByIndex(key), React.createElement("input", {
        autoComplete: "off",
        disabled: disabled,
        maxLength: length,
        name: "".concat(name, "_").concat(key),
        onBlur: this.handleInputOnBlur,
        onFocus: this.setFocusedElement,
        onChange: this.handleInputChange,
        onKeyUp: this.handleInputKeyUp,
        onKeyDown: this.handleInputKeyDown,
        onPaste: this.handlePaste,
        ref: this.inputRefs[key],
        placeholder: placeholder,
        size: length < 10 ? length : length + 4,
        className: className,
        style: {
          width: "".concat(this.calculateInputWidth(length), "px")
        },
        type: type,
        value: this.getInputValue(key)
      }), !separated && this.renderTeeth(length), !isLastGroup && React.createElement("span", _defineProperty({
        className: "delimiter"
      }, "className", classes.delimiter), showDelimiter && delimiter));
    }
  }, {
    key: "setCharWidth",
    value: function setCharWidth(span) {
      if (!span) {
        return;
      }

      var charWidth = span.getBoundingClientRect().width;
      this.setState({
        charWidth: charWidth
      });
    }
  }, {
    key: "renderWidthTest",
    value: function renderWidthTest() {
      var _this4 = this;

      var charWidth = this.state.charWidth;

      if (charWidth) {
        return null;
      }

      var _this$props9 = this.props,
          classes = _this$props9.classes,
          narrow = _this$props9.narrow;
      return React.createElement("span", {
        className: classnames(classes.char, narrow && classes.charSmall),
        style: {
          visibility: 'hidden'
        },
        ref: function ref(span) {
          return _this4.setCharWidth(span);
        }
      }, "O");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          classes = _this$props10.classes,
          fields = _this$props10.fields,
          label = _this$props10.label,
          separated = _this$props10.separated;
      var singleLabel = Array.isArray(label) ? null : label;

      if (separated) {
        return React.createElement(FieldContainer, _extends({}, this.props, {
          simplified: true,
          label: singleLabel,
          onClick: this.focusOnInput
        }), fields.map(this.renderInput, this), this.renderWidthTest());
      }

      return React.createElement(FieldContainer, _extends({}, this.props, {
        padded: true,
        value: true,
        label: singleLabel,
        onClick: this.focusOnInput
      }), React.createElement("div", {
        className: classes.container
      }, fields.map(this.renderInput, this)), this.renderWidthTest());
    }
  }]);

  return MultiField;
}(React.PureComponent);

_defineProperty(MultiField, "styleRoot", 'MultiField');

_defineProperty(MultiField, "defaultProps", _objectSpread({
  delimiter: '-',
  disabled: false,
  showDelimiter: true
}, FieldContainer.defaultProps));

export default injectStyles(styles)(MultiField);